/**
 * Utility for handling auth redirects on www.finderz.ai
 */

/**
 * Check if we're on www.finderz.ai
 */
export const isWwwSite = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.location.hostname === 'www.finderz.ai';
};

/**
 * Get the appropriate login URL
 * For www.finderz.ai, redirect directly to Keycloak auth
 */
export const getLoginUrl = (): string => {
  if (isWwwSite()) {
    // Direct redirect to Keycloak auth page
    // The app.finderz.ai will handle the proper OAuth flow with dynamic parameters
    return 'https://app.finderz.ai/login';
  }
  return '/login';
};

/**
 * Get the appropriate register URL
 */
export const getRegisterUrl = (): string => {
  if (isWwwSite()) {
    return 'https://app.finderz.ai/register';
  }
  return '/register';
};
